import { ORGANIZATION_NAME } from "utils/objects";
import { DRUG_LIST_PDF_URL, PROVIDER_FORMS_URL, COVERMED_URL, PROVIDER_LOGIN_URL, PROVIDER_URL } from "./urls";

export const MediCalPopUpContent = () => {
  return (
    <>
      {ORGANIZATION_NAME} would like to remind you beginning January 1, 2022, pharmacy services for
      Medi-Cal members will be administered under the program known as <b>"Medi-Cal Rx.”</b>
      <br/>
      <br/>
        <b>
          <u>Pharmacy services include</u>:
        </b>
        <br/>
        <br/>
        <b>
          Medications, Enteral, Medical Supplies, and Vaccines.
        <br/>
        <br/>

        The following link outlines in greater detail what drugs/vaccines will be covered by the State:</b>

      <br/>

      <a href={DRUG_LIST_PDF_URL} target="_blank">
        {DRUG_LIST_PDF_URL}
      </a>

      <br/>
      <br/>
      <b style={{ textAlign: 'center' }}><u>Under Medi-Cal Rx, there are two preferred ways for Prescribers to submit a <i>prior authorization</i> (PA)
          for medication to Magellan:</u></b>

      <br/>
      <br/>

      <b>1. CoverMyMeds® (CMM) PA</b>
      <br/>
      The CMM PA submission channel allows prescriber and pharmacies to initiate and submit PAs with covered
      alternatives and approvals given in real time. More information can be found in Reference Materials at
      <a href={PROVIDER_FORMS_URL} target="_blank">{PROVIDER_FORMS_URL}</a>
      in the Medi-Cal Rx: CoverMyMeds How-To Guide or on the CMM website: <a href={COVERMED_URL} target="_blank">{COVERMED_URL}</a>

      <br/>
      <br/>

      <b>2. Medi-Cal Rx Secured Provider Portal</b>
      <br/>
      Registered pharmacy providers and prescribers will be able to log in to the Secured Provider Portal at
      <a href={PROVIDER_LOGIN_URL} target="_blank">{PROVIDER_LOGIN_URL}</a>
      to submit, inquire about, cancel, or add additional information to existing PAs as well as attach
      documents to any PAs in progress.

      <br/>
      <br/>
      <p style={{ textAlign: 'center' }}>
        <b><u>What should Providers do right now to get ready for Medi-Cal Rx?</u></b>
      </p>
      <p>
        <br/>
        DHCS & Health Plans strongly encourage our Providers to visit & register at the new Medi-Cal Rx website
        ASAP, located here: <a href={PROVIDER_URL} target="_blank">{PROVIDER_URL}</a>
        <br/>
        <b>Please register for the Magellan Medi-Cal Rx Provider Portal today!</b>
      </p>

      <br/>
      <b style={{ color: 'red' }}>&nbsp; &nbsp; &nbsp; &nbsp; <u>Beginning 1/1/22, all Medi-Cal Rx covered items will NOT be accepted through the 
      {ORGANIZATION_NAME} portal.</u></b>
      By way of receiving this “Acknowledgement Notice,” the IPA Provider(s) are obligated to register their
      office on the new Medi-Cal Rx website <u>before 12/28/2021</u> and fully understand that Medi-Cal Rx is
      responsible for the authorization process of covered items under the program. Please click the button
      below to acknowledge you have read and understood the information above.
    </>
  );
};
